










import {Drag} from "vue-drag-drop";
import {Vue, Component, Prop} from "vue-property-decorator";
import DynamicComponents from "./DynamicComponents.vue";
import {SDynamicComponent} from "@/components/dto/SDynamicComponent";
import {ObjUtils} from "@/components/utils/ObjUtils";

@Component({
    components: {DynamicComponents,Drag}
})
export default class ComponentList extends Vue {
    @Prop() componentsProp!: any;
    @Prop() data!: any;
    private componentView: SDynamicComponent[] = this.components();

    openComponentSettings(item: any){
        this.handle_function_call('openComponentSettings', item);
    }
    handleDragstart(startData: any, event: any){
        this.handle_function_call('handleDragstart', [startData, event]);
    }
    handle_function_call(e: any, param: any) {
        this.$emit('callfunction', e, param);
    }

    components():SDynamicComponent[]{
        let coms: SDynamicComponent[] = [];
        if(typeof  this.componentsProp === 'string'){
            return ObjUtils.parseJsonString(this.componentsProp);
        }else {
            coms.push(this.componentsProp);
            return coms;
        }
    }
}
